import React from 'react';
import { Link } from 'gatsby';

const ButtonBack = ({ id }) => {
  return <Link className="detail-task-back-button" to={`/tarea/${id}`} />;
};

export default ButtonBack;
